export const NETWORK_ERROR_CODE = "ERR_NETWORK";

export const UNKNOWN_ERROR = "Oops, something went wrong";

export const PASSWORD_LENGTH_LIMITS = {
  MIN: 8,
  MAX: 99,
};

export const TEXT_LENGTH_LIMITS = {
  MIN: 3,
  MAX: 99,
};

export const EMAIL_LENGTH_LIMITS = {
  MIN: 6,
  MAX: 99,
};

export const LENGTH_MFA_CODE = 6;

export const REGEX_PASSWORD_REQUIRES =
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>_\-=+[\]\\/`~;'])[^\s].{7,}[^\s]$/;

export enum EnvType {
  DEV = "development",
  PROD = "production",
  LOCAL = "local",
}
